import React from "react";
import _ from "lodash";

import Button from "../../../components/base/Button";
import Glyphicon from "../../../components/base/Glyphicon";

import HelpToolTip from "../../../components/HelpTooltip";

import AppConstants from "../../../constants/AppConstants";
import AppColors from "../../../constants/AppColors";
import UIActions from "../../../actions/UIActions";

import AssetUtils from "../../../utils/AssetUtils";

class FaviconChooser extends React.Component {
  constructor(props) {
    super(props);

    this._onChoose = this._onChoose.bind(this);
    this._onRemove = this._onRemove.bind(this);
    this._onSelect = this._onSelect.bind(this);
  }

  _onChoose() {
    var config = {
      overlay: true,
      btnLabel: "Select",
      onSelect: this._onSelect,
      mode: AppConstants.ASSET_LIBRARY_MODE_CHOOSER,
      title: "Select Favicon",
      filterExts: ["png", "ico"],
    };

    UIActions.toggleAssetChooser(config);
  }

  _onSelect(asset) {
    //don't need all other asset information just the key and extension
    var favicon = _.pick(asset, ["key", "ext"]);

    if (this.props.onUpdate) {
      this.props.onUpdate(favicon);
    }
  }

  _onRemove() {
    if (this.props.onUpdate) {
      this.props.onUpdate(null);
    }
  }

  render() {
    let { favicon } = this.props;
    let iconPath = "/favicon.png";
    let view = null;

    if (favicon) {
      if ("ico" == favicon.get("ext")) {
        iconPath = AssetUtils.getOriginalURL(favicon.get("key"));
      } else {
        iconPath = AssetUtils.getV2PreviewURL(favicon.get("key"));
      }

      view = (
        <div style={{ display: "flex", alignItems: "flex-start", marginLeft: "1rem" }}>
          <div
            className={"favicon-preview-tab"}
            style={{ cursor: "pointer" }}
            onClick={this._onChoose}
          >
            <img src={iconPath} alt="" width="16" height="16" />
          </div>
          <Button
            style={{ paddingLeft: 10 }}
            look="link"
            title="Remove Favicon"
            onClick={this._onRemove}
          >
            <Glyphicon glyph="bin" />
          </Button>
        </div>
      );
    } else {
      view = (
        <Button look="link" style={{ color: AppColors.BLUE_BASE }} onClick={this._onChoose}>
          <Glyphicon glyph="picture" style={{ fontSize: 18, marginRight: 5, marginLeft: "1rem" }} />{" "}
          Choose Image
        </Button>
      );
    }

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {view}
        <HelpToolTip tooltipKey="favicon" placement="bottom-left" />
      </div>
    );
  }
}

export default FaviconChooser;
